import Vue from 'vue'
let baseUrl = process.env.VUE_APP_API_WORKSPACE_URL;
if(baseUrl.substring(baseUrl.length - 1) == "/")
    baseUrl = baseUrl.substring(0, baseUrl.length - 1);

baseUrl = `${baseUrl}/colaborador`;
export default{
    async listarPorId(id){
        return await Vue.prototype.$httpJson.get(`${baseUrl}/${encodeURI(id)}`);
    },   
    async listarPorLogin(login){
        return await Vue.prototype.$httpJson.get(`${baseUrl}/login/${encodeURI(login)}`);
    },    
    async listarPorDocumento(login){
        return await Vue.prototype.$httpJson.get(`${baseUrl}/documento/${encodeURI(login)}`);
    },        
    async listarPorEmail(email){
        return await Vue.prototype.$httpJson.get(`${baseUrl}/email/${encodeURI(email)}`);
    },        
    async listarPrimeiroNome(primeiroNome){
        return await Vue.prototype.$httpJson.get(`${baseUrl}/primeiro-nome/inicie/${encodeURI(primeiroNome)}`);
    },
    async listarUltimoNome(ultimoNome){
        return await Vue.prototype.$httpJson.get(`${baseUrl}/ultimo-nome/contenha/${encodeURI(ultimoNome)}`);
    },
    async listarFoto(id){
        return await Vue.prototype.$httpJson.get(`${baseUrl}/${id}/foto`);
    },    
    async listarNome(primeiroNome, ultimoNome){
        return await Vue.prototype.$httpJson.get(
            `${baseUrl}/nome/inicie?primeiroNome=${encodeURI(primeiroNome)}&ultimoNome=${encodeURI(ultimoNome)}`
        );
    } 
}